export default __webpack_public_path__ + "static/media/GC_2.2338b42e.png";